import React, { useEffect } from "react";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import NoModel from "../../Assets/Images/moModels.png";

const AssetsList = ({ list }) => {
  const navigate = useNavigate();

  const handleClickAsset = (id) => {
    navigate(`/asset/details/${id}`);
  };

  return (
    <>
      {list.length > 0 ? (
        <div className="asset-list">
          {list.map((item, index) => {
            return (
              <div key={item.uuid + "_" + index} className="asset-item" onClick={() => handleClickAsset(item.uuid)}>
                <div className="asset-thumb">
                  <img src={item.thumbnail} alt="thumbnail" />
                </div>
                <div className="asset-info">
                  <h6>{item.name}</h6>
                  <p>{moment(item.createdAt, "YYYYMMDD").fromNow()} </p>
                  <div className="tag-list">
                    {item.tags.slice(0, 2).map((e, i) => {
                      return <span key={i + 1}>{e.name}</span>;
                    })}

                    {item.tags.length > 2 && (
                      <Tooltip
                        title={item.tags.slice(2).map((e) => {
                          return e.name + ", ";
                        })}
                      >
                        <span>+{item.tags.length - 2}</span>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <>
          <div className="no-model">
            <img src={NoModel} alt="No Data Found" />
            <h6>No results found</h6>
          </div>
        </>
      )}
    </>
  );
};

export default AssetsList;
